import { render, staticRenderFns } from "./AgentDetails.vue?vue&type=template&id=fa3cb2ae&scoped=true&"
import script from "./AgentDetails.vue?vue&type=script&lang=js&"
export * from "./AgentDetails.vue?vue&type=script&lang=js&"
import style0 from "./AgentDetails.vue?vue&type=style&index=0&id=fa3cb2ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3cb2ae",
  null
  
)

export default component.exports